import React, { Component } from "react";
import Footer from "../../component/footer/Footer";
import Header from "../../component/header/Header";
import './Home.css';

class Home extends Component {
    render() {
        return (
            <div>
                <Header />
                <Footer />
            </div>
        )
    }
}

export default Home;